import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';

const principles = [
  { icon: 'ri-link', title: '每条都有出处', desc: '档案里每一条信息都标注来源类型，能对上的才写「已确认」。' },
  { icon: 'ri-emotion-normal-line', title: '不替谁站队', desc: '只整理公开信息，不评价当事人人品，也不替任何一方下结论。' },
  { icon: 'ri-lock-line', title: '隐私画好红线', desc: '不公开素人和未成年人的真实信息，涉及隐私的线索一律不展开。' },
];

const voices = [
  {
    name: '林小满',
    role: '追了三年瓜的老粉',
    text: '以前刷评论区总被带跑，现在会先来这儿看时间线。哪句在前哪句在后，一目了然。',
  },
  {
    name: '阿哲',
    role: '内容运营',
    text: '判定的分级很实用，「存疑」和「已确认」分开标，不会让人误以为所有爆料都是实锤。',
  },
  {
    name: '饼干不加糖',
    role: '职场打工人',
    text: '午休十分钟就能把整件事看完，比在各种营销号里翻半天清爽多了。',
  },
];

export default function AboutSection() {
  return (
    <section id="about" className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full px-4 md:px-6">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <SectionHeading
              kicker="关于西瓜瓜田"
              title="热闹可以有，理性不能少"
              desc="我们是一个专注娱乐线索整理的编辑部。不追最快，只追最清楚：把散落的讨论拼成一条能看懂的线，让吃瓜这件事少一点情绪，多一点依据。"
            />
            <ul className="mt-8 space-y-4">
              {principles.map((item) => (
                <li key={item.title} className="flex gap-4">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                    <i className={`${item.icon} text-xl`} />
                  </span>
                  <span>
                    <span className="block font-medium text-foreground-950">{item.title}</span>
                    <span className="mt-1 block text-sm leading-relaxed text-foreground-600">
                      {item.desc}
                    </span>
                  </span>
                </li>
              ))}
            </ul>
            <Link
              to="/about"
              className="mt-8 inline-flex cursor-pointer items-center gap-2 rounded-md border border-primary-300 bg-primary-100 px-5 py-3 text-sm font-medium text-primary-800 transition-colors hover:bg-primary-200"
            >
              了解更多内容原则
              <i className="ri-arrow-right-line" />
            </Link>
          </div>

          <div className="lg:col-span-7">
            <div className="rounded-lg border border-background-200 bg-background-100 p-6 md:p-8">
              <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
                <i className="ri-chat-smile-2-line text-primary-600" />
                读者怎么说
              </h3>
              <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2">
                {voices.map((voice, index) => (
                  <Reveal key={voice.name} delay={index * 80}>
                    <figure className="flex h-full flex-col rounded-md border border-background-200 bg-background-50 p-5">
                      <i className="ri-double-quotes-l text-2xl text-accent-500" />
                      <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                        {voice.text}
                      </blockquote>
                      <figcaption className="mt-4 flex items-center gap-3 border-t border-background-200 pt-4">
                        <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-sm font-bold text-background-50">
                          {voice.name.slice(0, 1)}
                        </span>
                        <span>
                          <span className="block text-sm font-medium text-foreground-950">{voice.name}</span>
                          <span className="block text-xs text-foreground-500">{voice.role}</span>
                        </span>
                      </figcaption>
                    </figure>
                  </Reveal>
                ))}
                <div className="flex h-full flex-col justify-center rounded-md bg-accent-100 p-5">
                  <p className="font-heading text-3xl font-black text-accent-900">96%</p>
                  <p className="mt-2 text-sm leading-relaxed text-accent-900">
                    读者表示，看完时间线后更能分辨哪些是推测、哪些有出处。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}